import { Card } from './card.jsx';
import { Skeleton } from './skeleton.jsx';
import { cn } from '../lib/utils.js';

/**
 * KPI tile. `value` must come from the API – never hardcode business figures.
 * When `value` is null/undefined and not loading, `emptyText` is shown.
 * @param {{
 *   label: import('react').ReactNode,
 *   value?: import('react').ReactNode,
 *   hint?: import('react').ReactNode,
 *   icon?: import('react').ComponentType<{ className?: string }>,
 *   loading?: boolean,
 *   emptyText?: import('react').ReactNode,
 *   className?: string,
 * }} props
 */
export function StatCard({ label, value, hint, icon: Icon, loading = false, emptyText = 'Noch keine Daten', className }) {
  const hasValue = value !== null && value !== undefined && value !== '';
  return (
    <Card className={cn('gap-2 px-4', className)}>
      <div className="flex items-center justify-between gap-2 text-sm text-muted-foreground">
        <span>{label}</span>
        {Icon && <Icon className="size-4" aria-hidden="true" />}
      </div>
      {loading ? (
        <Skeleton className="h-7 w-24" />
      ) : hasValue ? (
        <div className="numeric text-h1 font-semibold">{value}</div>
      ) : (
        <div className="text-sm text-muted-foreground">{emptyText}</div>
      )}
      {hint && <div className="text-xs text-muted-foreground">{hint}</div>}
    </Card>
  );
}
